import { useMutation, useQueryClient } from '@tanstack/react-query';
import { packageServices } from '../services/package.service';
import toast from 'react-hot-toast';

export const useTogglePackageStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ packageId, isActive }) => packageServices.updatePackage({ packageId, data: { isActive } }),

    onMutate: async ({ packageId, isActive }) => {
      await queryClient.cancelQueries({ queryKey: ['packages'] });
      const previousData = queryClient.getQueriesData({ queryKey: ['packages'] });

      queryClient.setQueriesData({ queryKey: ['packages'] }, (old) => {
        if (!old) return old;

        return {
          ...old,
          data: old.data?.map((pkg) => (pkg._id === packageId ? { ...pkg, isActive } : pkg)),
        };
      });

      return { previousData };
    },

    onError: (error, variables, context) => {
      if (context?.previousData) {
        context.previousData.forEach(([queryKey, data]) => {
          queryClient.setQueryData(queryKey, data);
        });
      }
      toast.error(error?.response?.data?.message || 'Failed to update package status');
    },

    onSuccess: () => {
      toast.success('Package status updated successfully');
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['packages'] });
    },
  });
};
